import { useEffect, useRef } from 'react';
import { MONITOR_LOAD_MORE_ROOT_MARGIN } from '../../constants';

interface LoadMoreTriggerProps {
  onLoadMore: () => void;
}

export function LoadMoreTrigger({ onLoadMore }: LoadMoreTriggerProps) {
  const triggerRef = useRef<HTMLDivElement>(null);
  const onLoadMoreRef = useRef(onLoadMore);
  onLoadMoreRef.current = onLoadMore;

  useEffect(() => {
    const trigger = triggerRef.current;

    if (!trigger) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onLoadMoreRef.current();
        }
      },
      { rootMargin: MONITOR_LOAD_MORE_ROOT_MARGIN },
    );

    observer.observe(trigger);

    return () => observer.disconnect();
  }, []);

  return <div ref={triggerRef} aria-hidden="true" />;
}
